import React, { useEffect, useMemo } from "react";

import { useTranslation } from "react-i18next";

import { useFormContext, Controller } from "react-hook-form";

import FormSimple from "@components/formGroup/formSimple";
import InputWithAddOptions from "@components/input/InputWithAddOptions";

// import {
//   REGEX_ACCOUNT_NUMBER,
//   REGEX_POST_NUMBER,
//   REGEX_SOCIAL_NUMBER,
//   REGEX_TRANSIT_NUMBER,
//   REGEX_PLAN_NUMBER_CERTIFICATE_MEMBER
// } from "@helpers/_constants";
import { checkEnterpriseId } from "@helpers/_functions";

import useInsuranceAndCoverageType from "./helpers/_functions";
import { useDispatch } from "react-redux";
import { insuranceAndCoverageActions } from "@store/actions/settings/_insuranceNumberAndCoverageTypeActions";
import { useUserPermission } from "@hooks/users";

function SectionBankAssurance({ canAccessBankingInfo = false, readOnly = false, isEnterprisePage }) {
  const { t: mainTranslator } = useTranslation("pages.employés.emploi&Salary");
  const { control } = useFormContext();
  const reduxDispatch = useDispatch();
  const {
    insurancePlanNumberList,
    coverageTypeList,
    addInsurancePlanNumber,
    deleteInsurancePlanNumber,
    addCoverageType,
    deleteCoverageType
  } = useInsuranceAndCoverageType();

  const { canAccessInsuranceSocialNumber, canAccessBankingInformation } = useUserPermission();
  const readOnlyInsuranceSocialNumber = useMemo(() => {
    return isEnterprisePage ?
      (readOnly || !Boolean(canAccessBankingInfo)) :
      (readOnly && !canAccessInsuranceSocialNumber);
  }, [canAccessBankingInfo, canAccessInsuranceSocialNumber, readOnly, isEnterprisePage])

  const readOnlyBankingInformation = useMemo(() => {
    return isEnterprisePage ?
      (readOnly || !Boolean(canAccessBankingInfo)) :
      (readOnly && !canAccessBankingInformation);
  }, [canAccessBankingInfo, canAccessBankingInformation, readOnly, isEnterprisePage])


  useEffect(() => {
    reduxDispatch(insuranceAndCoverageActions.loadData);
  }, []);

  return (
    <div className="arh-w-full arh-pb-[2rem] arh-pl-[5.8rem] arh-pr-[2.938rem]">
      <div className="arh-grid arh-grid-cols-5 arh-gap-4 arh-w-full arh-border-x-0 arh-border-b arh-border-t-0 arh-border-solid arh-border-b-borderTable arh-pb-4">
        <Controller
          control={control}
          name="BankingAndInsuranceInformation.transitNumber"
          defaultValue=""
          // rules={{
          //   validate: {
          //     validationForTransit: (value) =>
          //       value === "" || REGEX_TRANSIT_NUMBER.test(value)
          //   }
          // }}
          render={({
            field: { onChange, value },
            // fieldState: { invalid }
          }) => (
            <FormSimple
              label={mainTranslator("Numéro de transit")}
              //placeholder={mainTranslator("Numéro de transit")}
              placeholder="00000"
              ParentForm=" "
              classLabel="arh-flex"
              value={value}
              onChange={onChange}
              custombutton="!arh-hidden "
              classInput="!arh-border-r !arh-rounded-br !arh-rounded-tr "
              // invalid={invalid}
              readOnly={readOnlyBankingInformation}
            />
          )}
        />

        <Controller
          control={control}
          name="BankingAndInsuranceInformation.institutionNumber"
          defaultValue=""
          // rules={{
          //   validate: {
          //     validationForInstitution: (value) =>
          //       value === "" || REGEX_POST_NUMBER.test(value)
          //   }
          // }}
          render={({
            field: { onChange, value },
            // fieldState: { invalid }
          }) => (
            <FormSimple
              label={mainTranslator("Numéro d'institution")}
              //placeholder={mainTranslator("Numéro d'institution")}
              placeholder="000"
              ParentForm=" "
              classLabel="arh-flex"
              value={value}
              onChange={onChange}
              custombutton="!arh-hidden "
              classInput="!arh-border-r !arh-rounded-br !arh-rounded-tr "
              // invalid={invalid}
              readOnly={readOnlyBankingInformation}
            />
          )}
        />

        <Controller
          control={control}
          name="BankingAndInsuranceInformation.accountNumber"
          defaultValue=""
          // rules={{
          //   validate: {
          //     validationForAccount: (value) =>
          //       value === "" || REGEX_ACCOUNT_NUMBER.test(value)
          //   }
          // }}
          render={({
            field: { onChange, value },
            // fieldState: { invalid }
          }) => (
            <FormSimple
              label={mainTranslator("Numéro de compte")}
              placeholder="000000000000"
              ParentForm="arh-mb-[1.75rem]"
              classLabel="arh-flex"
              value={value}
              onChange={onChange}
              custombutton="!arh-hidden "
              // invalid={invalid}
              classInput="!arh-border-r !arh-rounded-br !arh-rounded-tr "
              readOnly={readOnlyBankingInformation}
            />
          )}
        />
      </div>

      <div className="arh-grid arh-grid-cols-5 arh-gap-4 arh-mt-[1.75rem] arh-w-full arh-items-center arh-border-x-0 arh-border-b arh-border-t-0 arh-border-solid arh-border-b-borderTable">
        <Controller
          control={control}
          name="BankingAndInsuranceInformation.socialInsuranceNumber"
          defaultValue=""
          // rules={{
          //   validate: {
          //     validationForInsurance: (value) =>
          //       value === "" || REGEX_SOCIAL_NUMBER.test(value)
          //   }
          // }}
          render={({
            field: { onChange, value },
            // fieldState: { invalid }
          }) => (
            <FormSimple
              label={mainTranslator("Numéro d'assurance sociale")}
              //placeholder={mainTranslator("Numéro d'assurance social")}
              placeholder="000000000"
              ParentForm="arh-mb-[1.75rem]"
              classLabel="arh-flex"
              value={value}
              onChange={onChange}
              custombutton="!arh-hidden "
              classInput="!arh-border-r !arh-rounded-br !arh-rounded-tr "
              // invalid={invalid}
              readOnly={readOnlyInsuranceSocialNumber}
            />
          )}
        />
      </div>

      <div className="arh-mt-[1.75rem] arh-grid arh-grid-cols-5 arh-gap-4 arh-w-full">
        <Controller
          control={control}
          name="BankingAndInsuranceInformation.planNumber"
          defaultValue=""
          // rules={{
          //   validate: {
          //     validationForPlanNumber: (value) =>
          //       value === "" || REGEX_PLAN_NUMBER_CERTIFICATE_MEMBER.test(value)
          //   }
          // }}
          render={({
            field: { onChange, value }
          }) => (
            <FormSimple
              label={mainTranslator("Numéro de régime")}
              placeholder="00000"
              ParentForm=" "
              classLabel="arh-flex"
              value={value}
              onChange={onChange}
              custombutton="!arh-hidden "
              classInput="!arh-border-r !arh-rounded-br !arh-rounded-tr "
              readOnly={readOnlyInsuranceSocialNumber}
            />
          )}
        />

        <Controller
          control={control}
          name="BankingAndInsuranceInformation.memberCertificateNumber"
          defaultValue=""
          // rules={{
          //   validate: {
          //     validationForMemberCertificateNumber: (value) =>
          //       value === "" || REGEX_PLAN_NUMBER_CERTIFICATE_MEMBER.test(value)
          //   }
          // }}
          render={({
            field: { onChange, value }
          }) => (
            <FormSimple
              label={mainTranslator("Numéro de certificat d'adhérent")}
              placeholder="00000"
              ParentForm=" "
              classLabel="arh-flex"
              value={value}
              onChange={onChange}
              custombutton="!arh-hidden "
              classInput="!arh-border-r !arh-rounded-br !arh-rounded-tr "
              readOnly={readOnlyInsuranceSocialNumber}
            />
          )}
        />


        <Controller
          control={control}
          name="BankingAndInsuranceInformation.insurancePlanNumber"
          defaultValue=""
          render={({ field: { onChange, value, name } }) => (
            <div className=" arh-flex arh-flex-col">
              <label className={`arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium ${readOnlyInsuranceSocialNumber ? "arh-text-greyDisabledText" : "arh-text-darkColor"}`}>
                {mainTranslator("Numéro de plan d'assurance")}
              </label>
              <InputWithAddOptions
                defaultText="00000"
                classInput="desktop-middle:arh-pr-20"
                classBtn="desktop-middle:arh-px-2"
                optionsList={insurancePlanNumberList || []}
                secondDefaultText={mainTranslator("Ajouter")}
                name={name}
                optionListLabel="name"
                onChange={(event) => {
                  onChange(event?.target?.dataset.value || null);
                }}
                showAction={true}
                value={value}
                hideEdit={true}
                disableInputChange={true}
                addItem={(data) =>
                  addInsurancePlanNumber({
                    ...data,
                    entreprise: checkEnterpriseId()
                  })
                }
                deleteItem={deleteInsurancePlanNumber}
                disabled={readOnlyInsuranceSocialNumber}
              />
            </div>
          )}
        />


        <Controller
          control={control}
          name="BankingAndInsuranceInformation.typeCover"
          defaultValue=""
          render={({ field: { onChange, value, name } }) => (
            <div className=" arh-w-full">
              <label className={`arh-mb-1 arh-flex arh-w-full arh-font-poppins arh-text-xs arh-font-medium ${readOnlyInsuranceSocialNumber ? "arh-text-greyDisabledText" : "arh-text-darkColor"}`}>
                {mainTranslator("Type de couverture")}
              </label>
              <InputWithAddOptions
                defaultText="00000"
                classInput="desktop-middle:arh-pr-20"
                classBtn="desktop-middle:arh-px-2"
                optionsList={coverageTypeList || []}
                secondDefaultText={mainTranslator("Ajouter")}
                name={name}
                optionListLabel="name"
                onChange={(event) => {
                  onChange(event?.target?.dataset.value || null);
                }}
                showAction={true}
                value={value}
                hideEdit={true}
                disableInputChange={true}
                addItem={(data) =>
                  addCoverageType({
                    ...data,
                    entreprise: checkEnterpriseId()
                  })
                }
                deleteItem={deleteCoverageType}
                disabled={readOnlyInsuranceSocialNumber}
              />
            </div>
          )}
        />
      </div>
    </div>
  );
}

export default SectionBankAssurance;
